import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Confirm, Loading } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

function AddressRow({ a, i, editable, onSave, onDelete }) {
  const [name, setName] = useState(a.name);
  const dirty = name !== a.name;
  return (
    <tr data-testid={`address-row-${i}`}>
      <td className="rownum">{i + 1}</td>
      <td className="cell-edit"><input className={`xl-input text-left ${dirty ? "dirty" : ""}`} value={name} onChange={(e) => setName(e.target.value)} disabled={!editable} data-testid={`address-name-${i}`} /></td>
      <td className="num">{a.customer_count}</td>
      {editable && (
        <td className="whitespace-nowrap">
          <Button size="sm" variant="ghost" disabled={!dirty} onClick={() => onSave(a, name)} data-testid={`address-save-${i}`}><Save className="h-4 w-4" /></Button>
          <Confirm title="Hapus alamat?" description={a.name} onConfirm={() => onDelete(a)} testId={`address-delete-${i}`}
            trigger={<Button size="sm" variant="ghost" className="text-rose-600" data-testid={`address-delete-${i}`}><Trash2 className="h-4 w-4" /></Button>} />
        </td>
      )}
    </tr>
  );
}

export function AddressList() {
  const { can } = useAuth();
  const editable = can("address:write");
  const [rows, setRows] = useState(null);
  const [nw, setNw] = useState("");
  const load = useCallback(async () => {
    try { setRows((await api.get("/addresses")).data); } catch (e) { toast.error(errMsg(e)); }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const run = async (fn, msg) => {
    try { await fn(); toast.success(msg); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const add = () => nw.trim() && run(async () => { await api.post("/addresses", { name: nw }); setNw(""); }, "Alamat ditambahkan");
  if (!rows) return <Loading />;
  return (
    <div className="xl-wrap max-w-2xl" data-testid="address-list">
      <table className="xl">
        <thead><tr><th className="rownum">#</th><th>Nama Alamat / Wilayah</th><th className="text-right">Pelanggan</th>{editable && <th>Aksi</th>}</tr></thead>
        <tbody>
          {rows.map((a, i) => (
            <AddressRow key={a.id + a.name} a={a} i={i} editable={editable}
              onSave={(x, name) => run(() => api.put(`/addresses/${x.id}`, { name }), "Alamat disimpan")}
              onDelete={(x) => run(() => api.delete(`/addresses/${x.id}`), "Alamat dihapus")} />
          ))}
          {editable && (
            <tr className="bg-emerald-50/40">
              <td className="rownum">+</td>
              <td className="cell-edit"><input className="xl-input text-left" placeholder="mis. Dusun Krajan RT 01" value={nw} onChange={(e) => setNw(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} data-testid="address-new-input" /></td>
              <td />
              <td><Button size="sm" onClick={add} className="bg-emerald-700 hover:bg-emerald-800" data-testid="address-add-btn">Tambah</Button></td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
